import { isMachineInvoice } from "./invoiceHelper";
import { i18n } from "../shared/language";

export type MultiInvoiceActionName = "Điều chỉnh" | "Thay thế";
export type MultiInvoiceAction = MultiInvoiceActionName | "substitute" | "adjustment";

const getActionTranslationKey = (actionName: MultiInvoiceAction): string =>
  actionName === "Thay thế" || actionName === "substitute"
    ? "common.replacement"
    : "common.adjustment";

export const getMultiInvoiceCashRegisterError = (
  actionName: MultiInvoiceAction,
): string =>
  i18n.t("validation.multiInvoiceCashRegisterRestricted", {
    actionName: i18n.t(getActionTranslationKey(actionName)),
  });

/**
 * Lấy thông báo khi mẫu hóa đơn mua bán xe chưa được hỗ trợ nghiệp vụ nhiều hóa đơn.
 *
 * @returns Thông báo đã được dịch theo ngôn ngữ hiện tại.
 */
export const getMultiInvoiceRegisteredAssetError = (): string =>
  i18n.t("validation.multiInvoiceRegisteredAssetRestricted");

/**
 * Kiểm tra các điều kiện chung trước khi mở chức năng điều chỉnh/thay thế nhiều hóa đơn.
 *
 * @param invoiceSerial Ký hiệu của mẫu hóa đơn đang thao tác.
 * @param actionName Tên nghiệp vụ điều chỉnh hoặc thay thế.
 * @param showError Hàm hiển thị lỗi cho người dùng.
 * @param typeCompany Loại doanh nghiệp của mẫu hóa đơn.
 * @returns `true` khi được phép tiếp tục mở chức năng.
 */
export const validateMultiInvoiceAction = (
  invoiceSerial: unknown,
  actionName: MultiInvoiceAction,
  showError: (message: string) => void,
  typeCompany?: unknown,
): boolean => {
  // Mẫu 01/BTS không hỗ trợ điều chỉnh hoặc thay thế nhiều hóa đơn nên phải chặn ngay tại thao tác mở chức năng.
  if (Number(typeCompany) === 9) {
    showError(getMultiInvoiceRegisteredAssetError());
    return false;
  }

  if (typeof invoiceSerial !== "string" || !invoiceSerial.trim()) {
    return false;
  }

  if (isMachineInvoice(invoiceSerial.trim())) {
    showError(getMultiInvoiceCashRegisterError(actionName));
    return false;
  }

  return true;
};
